import { AppState } from 'services/types';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { SprayWaterRate } from 'services/sprayEvents/types';
import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';
import { HALF_THE_CALCULATION } from 'services/sprayEvents/constants';
import { OwnProps } from './index';
import {
    selectEffectiveRatio,
    selectTotalArea
} from '../../../../../../selectors';

const selectWaterRate = (state: AppState, props: OwnProps): SprayWaterRate =>
    props.waterRate;

const selectNeedHalfCalculation = (state: AppState, props: OwnProps): boolean =>
    props.needHalfCalculation;

const selectWaterTotal = createDeepEqualSelector(
    selectWaterRate,
    selectTotalArea,
    selectEffectiveRatio,
    selectSprayEventTypeIsWeed,
    selectNeedHalfCalculation,
    (
        waterRate,
        totalArea,
        effectiveRatio,
        isWeedSpray,
        needHalfCalculation
    ) => {
        const denominator = needHalfCalculation ? HALF_THE_CALCULATION : 1;
        if (isWeedSpray) {
            return Number(
                (
                    (waterRate * totalArea * effectiveRatio) /
                    denominator
                ).toFixed(2)
            );
        }

        return Number(((waterRate * totalArea) / denominator).toFixed(2));
    }
);

const makeSelectWaterTotal = (): typeof selectWaterTotal => selectWaterTotal;

export { selectWaterRate, makeSelectWaterTotal };
